export default __webpack_public_path__ + "static/media/homefree.53778a37.jpg";